<template>
  <div class="assetTable">
    <v-data-table
      class="custom-price-data-table gray10"
      :no-data-text="$t('common.nodata')"
      :headers="headers"
      :items="dataTable"
      fixed-header
      hide-default-footer
      disable-pagination
      :header-props="{ 'sort-icon': '$sortIcon' }"
      ref="table"
    >
      <template v-slot:item.coin="{ item }">
        <div class="d-flex justify-start align-center">
          <img
            v-if="item.logoUrl"
            :src="item.logoUrl"
            height="20"
            width="20"
            @error="setDefaultLogo"
          />
          <img
            v-else
            :src="require('@/assets/image/coin_place_holder.png')"
            height="20"
            width="20"
            @error="setDefaultLogo"
          />
          <div class="ms-2">
            <div class="font-Regular-12">
              {{ item.displayName }}
            </div>
            <div class="font-Regular-10 gray-text">
              {{ item.unit }}
            </div>
          </div>
        </div>
      </template>
      <template v-slot:item.strBalance="{ item }">
        {{
          hideAssets
            ? "*****"
            : $thousandMask(
                parseFloat(item.strFrozenBalance) + parseFloat(item.strBalance),
                item.frontCoinScale
              )
        }}
      </template>
      <template v-slot:header.usd_irr="">
        {{ balanceType ? $t("assets.usdBalance") : $t("assets.irrBalance") }}
      </template>
      <template v-slot:item.usd_irr="{ item }">
        <span v-if="balanceType">
          {{ hideAssets ? "*****" : $thousandMask(item.strUSD_Balance) }}
        </span>
        <span v-else>
          {{ hideAssets ? "*****" : $thousandMask(item.strIRR_Balance) }}
        </span>
      </template>
      <template v-slot:item.strFrozenBalance="{ item }">
        {{
          hideAssets
            ? "*****"
            : $thousandMask(item.strFrozenBalance, item.frontCoinScale)
        }}
      </template>
      <template v-slot:item.operation="{ item }">
        <v-btn
          v-if="item.coinType === 'VIRTUAL'"
          text
          style="color:rgb(241, 172, 25);border-color: rgb(241, 172, 25);background-color: transparent"
          @click="coinTypeDescriptionModal = true"
        >
          {{ $t("assets.trialCurrency") }}
        </v-btn>
        <!--        withdrawal-->
        <v-btn
          v-else-if="item.canTransfer === 1 && item.isLock === 0"
          text
          color="error"
          style="margin-right: 8px"
          @click="() => withdrawalHanlder(item)"
        >
          {{ $t("assets.transfer") }}
        </v-btn>
        <v-btn v-else text disabled style="margin-right: 8px">
          {{ $t("assets.transfer") }}
        </v-btn>
        <!--      not  virtual-->
        <v-btn text v-if="item.coinType !== 'VIRTUAL'">
          <v-select
            :disabled="!item.baseCoinList.length > 0"
            :items="item.baseCoinList"
            outlined
            dense
            hide-details
            :menu-props="{ bottom: true, offsetY: true }"
            style="max-width: 70px;"
            @change="name => tradeHandler(name, item)"
          >
            <template v-slot:label>
              <span>{{ $t("assets.trade") }}</span>
            </template>
          </v-select>
        </v-btn>
      </template>
    </v-data-table>

    <v-dialog v-model="coinTypeDescriptionModal" width="450">
      <v-card>
        <v-card-title>
          {{ $t("assets.demoTrading") }}
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text class="mt-4">
          {{ $t("assets.modalText01") }}
        </v-card-text>
        <v-card-text>
          {{ $t("assets.modalText02") }}
        </v-card-text>
        <v-card-text>
          {{ $t("assets.modalText03") }}
        </v-card-text>
        <v-card-actions>
          <div class="text-left mt-4">
            <v-btn
              color="primaryX"
              style="color:#fff;"
              @click="coinTypeDescriptionModal = false"
            >
              {{ $t("common.getRealized") }}
            </v-btn>
          </div>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import $thousandMask from "@/mixins/thousandMask";
import UserCenter from "@/services/modules/market/userCenter";

export default {
  mixins: [$thousandMask],
  props: {
    dataTable: {
      type: Array
    },
    loading: {
      type: Boolean
    },
    balanceType: {
      type: Boolean
    },
    hideAssets: {
      type: Boolean
    }
  },
  data() {
    return {
      headers: [
        {
          text: this.$t("assets.crypto"),
          value: "coin",
          align: ""
        },
        {
          text: this.$t("assets.balance"),
          value: "strBalance",
          sortable: false,
          align: ""
        },
        {
          text: "",
          value: "usd_irr",
          align: ""
        },
        {
          text: this.$t("assets.frozen"),
          value: "strFrozenBalance",
          align: ""
        },
        {
          text: this.$t("assets.operation"),
          value: "operation",
          sortable: false,
          align: "center"
        }
      ],
      marketBaseUrl: process.env.VUE_APP_MARKET_BASE_URL,
      coinTypeDescriptionModal: false,
      tableColumnsMoneyHeader: [],
      userInfo: {}
    };
  },
  created() {
    UserCenter.checkLogin().then(response => {
      this.userInfo = response.data.data;
    });
  },
  methods: {
    setDefaultLogo(e) {
      e.target.src = require("@/assets/image/coin_place_holder.png");
    },
    withdrawalHanlder(item) {
      if (this.userInfo.withdrawStatus) {
        this.$router.push("/withdraw?name=" + item.unit);
      } else {
        this.$toast.error(this.$t("assets.disabledTransfer"));
      }
    },
    tradeHandler(name, item) {
      let pair = `${item.unit.toLowerCase()}_${name.toLowerCase()}`;
      window.location.href = `${this.marketBaseUrl}/exchange/${pair}`;
    }
  }
};
</script>

<style lang="scss">
.assetTable {
  .theme--light.v-label {
    color: #500fe9;
  }

  .theme--dark.v-label {
    color: #500fe9;
  }

  .theme--light.v-label--is-disabled {
    all: unset !important;
  }

  .theme--dark.v-label--is-disabled {
    all: unset !important;
  }

  .v-text-field--outlined.v-input--dense .v-label--active {
    all: unset;
  }

  .v-text-field.v-input--is-focused .v-input__slot,
  .v-text-field:hover .v-input__slot {
    border: 0 !important;
  }

  .v-text-field--outlined fieldset {
    border: 0 !important;

    &:hover,
    &:focus {
      border: 0 !important;
    }
  }

  .v-input__append-inner {
    display: none !important;
  }
}
</style>
